import { Formik, FieldArray, Field } from "formik";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { validation } from "./Shop.validation";
import {
  createShop,
  updateShop,
  updateBilling,
  updatePermission,
  createEnvVariable,
  updateEnvVariable,
  getShopById,
} from "../../services/shop.service";
import Step1 from "./ShopStepper/Step1";
import { toast } from "react-hot-toast";
import { useLocation } from "react-router-dom";

const initialState: any = {
  id: 0,
  username: "",
  password: "",
  newpassword: "",
  role: "",
  is_active: false,
  is_common: false,
  is_trial: true,
  trial_day: 0,
  email: "",
  phone: "",
  name: "",
  is_franchise: false,
  number_of_order: 100,
  number_of_food: 10,
  number_of_category: 10,
  number_of_table: 10,
  permissions: [],
  toggle: false,
  billing: {
    id: 0,
    name: "",
    address: "",
    phone: "",
    email: "",
    website: "",
    gst_no: "",
    fssai_no: "",
  },
  autoGeneratePassword: false,
  env_variable: [],
};

const Shop = (props: any) => {
  const [step, setStep] = useState(0);
  const [details, setDetails] = useState(initialState);
  const [shopId, setShopId] = useState(0);
  const username = useParams<{ id: string }>();
  const [shopDataById, setShopDataById] = useState(initialState);

  useEffect(() => {
    if (localStorage.getItem("token") === "Admin") {
      if (props.location.details) {
        setDetails(props.location.details);
        setShopId(props?.location?.details?.id);
      }
      // const username = props?.match?.params?.username;
      // console.log("username", username);
      getShopById(username?.id)
        .then((res) => {
          setShopDataById({ ...res?.data, toggle: false });
        })
        .catch((e) => {
          console.log(e);
          toast.error("Something went wrong.");
        });
    } else {
      props.history.push("/login");
    }
  }, []);

  const onBack = () => {
    if (step !== 0) {
      setStep(step - 1);
    }
  };

  const handleStepSubmit = async (value: any) => {
    if (step === 0) {
      const data: any = {
        id: value.id || 0,
        username: value.username,
        password: value.password,
        name: value.name,
        email: value.email,
        phone: value.phone,
        is_common: value.is_common,
        is_active: value.is_active,
        is_trial: value.is_trial,
        is_franchise: value.is_franchise,
        number_of_order: value.number_of_order,
        number_of_food: value.number_of_food,
        number_of_category: value.number_of_category,
        number_of_table: value.number_of_table,
        trial_day: value.trial_day,
      };
      if (data.id === 0) {
        try {
          await createShop(data).then((result) => {
            if (result?.data?.statusCode == 200) {
              toast.success(result.data.message);
              setStep(1);
              setShopId(result.data?.data?.id);
              props.history.push("/shop");
            } else {
              toast.error(result?.data?.message);
            }
          });
        } catch (err: any) {
          toast.error("Something went wrong, Please check username & email.");
        }
      } else {
        if (!value.toggle) {
          if (shopDataById.franchise_name) {
            data.franchise_name = shopDataById["franchise_name"];
          }
          const { password, ...rest } = data;
          updateShop(data.id, rest)
            .then((res: any) => {
              if (res?.status == 200) {
                toast.success(res.message);
                if (localStorage.getItem("redirect")?.trim() != "")
                  props.history.push(
                    `/shoplist/${localStorage.getItem("redirect")}`
                  );
                else props.history.push("/shop");
              } else {
                toast.error(res.message);
              }
            })
            .catch((err) => toast.error(err.message));
        } else {
          if (shopDataById.franchise_name) {
            data.franchise_name = shopDataById["franchise_name"];
          }
          data.password = value.newpassword;
          updateShop(data.id, data)
            .then((res: any) => {
              if (res?.status == 200) {
                toast.success(res.message);
                if (localStorage.getItem("redirect")?.trim() != "")
                  props.history.push(
                    `/shoplist/${localStorage.getItem("redirect")}`
                  );
                else props.history.push("/shop");
              } else {
                toast.error(res.message);
              }
            })
            .catch((err) => toast.error(err.message));
        }
      }
    } else if (step === 1) {
      const data = {
        id: value.billing?.id || 0,
        shop_id: shopId || value.id,
        name: value.billing.name,
        address: value.billing.address,
        email: value.billing.email,
        phone: value.billing.phone,
        website: value.billing.website,
        gst_no: value.billing.gst_no,
        fssai_no: value.billing.fssai_no,
        username: value.username,
      };
      updateBilling(data)
        .then((res: any) => {
          toast.success(res.message);
          setStep(2);
        })
        .catch((err) => toast.error(err.message));
    } else if (step === 2) {
      const data = {
        id: value.id,
      };
      const envdata = {
        shop_id: shopId,
        env_variable: value.env_variable,
        username: value.username,
      };
      if (data.id === 0) {
        createEnvVariable(envdata)
          .then((res: any) => {
            toast.success(res.message);
            setStep(3);
          })
          .catch((err) => toast.error(err.message));
      } else {
        updateEnvVariable(envdata)
          .then((res: any) => {
            toast.success("Env_Variable Update Success.");
            setStep(3);
          })
          .catch((err) => {
            toast.error("Env_Variable Update Failed.");
          });
      }
    } else if (step === 3) {
      const data = {
        shop_id: shopId || value.id,
        permissions: value.permissions,
        username: value.username,
      };
      updatePermission(data)
        .then((res: any) => {
          toast.success(res.message);
          props.history.push("/shop");
        })
        .catch((err) => toast.error(err.message));
    }
  };

  const changeStep = (stepNo: any) => {
    setStep(stepNo);
  };

  return (
    <Formik
      onSubmit={(values) => handleStepSubmit(values)}
      enableReinitialize={true}
      initialValues={shopDataById}
      validate={(values) => {
        return validation(values, step);
      }}
    >
      {({
        handleSubmit,
        values,
        handleChange,
        errors,
        setFieldValue,
        touched,
      }) => (
        <>
          <form onSubmit={handleSubmit}>
            <div className="page-title clearfix">
              <button
                className="back-button mt-1"
                title="Back"
                onClick={() => props.history.push("/shop")}
              ></button>
              {step === 0 ? (
                <button className="btn btn-primary primary-out" type="submit">
                  Save & Next
                </button>
              ) : (
                <>
                  <button
                    className="btn btn-secondary secondary-out mr-1"
                    onClick={onBack}
                    type="button"
                  >
                    Previous
                  </button>
                  {step === 3 ? (
                    <button
                      className="btn btn-primary primary-out"
                      type="submit"
                    >
                      Submit
                    </button>
                  ) : (
                    <button
                      className="btn btn-primary primary-out"
                      type="submit"
                    >
                      Save & Next
                    </button>
                  )}
                </>
              )}
            </div>
            <div className="content-box">
              <div className="content-body">
                {/* <ul className="device-step">
                  <li
                    className={step === 0 ? "active" : ""}
                    onClick={() => {
                      changeStep(0);
                    }}
                  >
                    <a href="#">1</a>
                  </li>
                  <li
                    className={step === 1 ? "active" : ""}
                    onClick={() => {
                      changeStep(1);
                    }}
                  >
                    <a href="#">2</a>
                  </li>
                  <li
                    className={step === 2 ? "active" : ""}
                    onClick={() => {
                      changeStep(2);
                    }}
                  >
                    <a href="#">3</a>
                  </li>
                  <li
                    className={step === 3 ? "active" : ""}
                    onClick={() => {
                      changeStep(3);
                    }}
                  >
                    <a href="#">4</a>
                  </li>
                </ul> */}
                <div>
                  {step === 0 && (
                    <Step1
                      shopId={shopId}
                      handleChange={handleChange}
                      errors={errors}
                      values={values}
                      touched={touched}
                    />
                  )}
                  {/* {step === 1 && (
                      <Step2
                        handleChange={handleChange}
                        errors={errors}
                        values={values}
                        setFieldValue={setFieldValue}
                        touched={touched}
                      />
                    )}
                    {step === 2 && (
                      <Step3
                        handleChange={handleChange}
                        errors={errors}
                        values={values}
                        setFieldValue={setFieldValue}
                        touched={touched}
                      />
                    )}
                    {step === 3 && (
                      <Step4 values={values} setFieldValue={setFieldValue} />
                    )} */}
                </div>
              </div>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default Shop;
